import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useCountryList(params) {
  return useSWR(
    !!params
      ? {
          path: `/api/v1/countries`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useCountryList;
